import { createContext, ReactNode } from 'react';
import { ButtonVariants } from 'components/button';

export enum AppNotificationType {
  CartItemSoldOut = 'CartItemSoldOut',
  CartItemSoldOutEmpty = 'CartItemSoldOutEmpty',
  CartItemExpired = 'CartItemExpired',
  CartItemExpiringSoon = 'CartItemExpiringSoon',
  CartItemQuantityAdjusted = 'CartItemQuantityAdjusted',
  CartItemSellingFast = 'CartItemSellingFast',
  ProductAddedToCart = 'ProductAddedToCart',
  StaffProductNotification = 'StaffProductNotification',
}

export interface AppNotification {
  type: AppNotificationType;
  isSingular?: boolean;
  positionBottom?: boolean;
  disableOutsideClose?: boolean;
  actions: {
    disableAllOtherActions?: boolean;
    loadDismissOnClick?: boolean;
    actionLabel: string;
    actionCallback: () => void;
    variant?: ButtonVariants;
  }[];
  body: ReactNode;
}

export interface NotificationsContextType {
  addNotification: (notification: AppNotification) => void;
  removeNotification: (notification: AppNotification) => void;
}

const NotificationsContext = createContext<NotificationsContextType>({
  addNotification: () => null,
  removeNotification: () => null,
});

export default NotificationsContext;
